import { createSlice } from '@reduxjs/toolkit';
const initialValues = {
index:0
}

const ViewDetailsStoreSlice = createSlice({
    name: 'ViewDetailsStore',
    initialState: initialValues,
    reducers : {
        updateIndex(state, action) {
            state.index = action.payload
        }
      
    }
})

export const ViewDetailsStoreAction = ViewDetailsStoreSlice.actions;

export default ViewDetailsStoreSlice.reducer;
